export default class FaqSection {
    static init(): void {
        const faqSections = document.querySelectorAll('.js-faq-section-init');
        if (!faqSections.length) {
            return;
        }

        this.faqItemInit();
        this.initResizeHandler();

        if (document.readyState === 'complete') {
            this.recalculateOpenItems();
        } else {
            window.addEventListener(
                'load',
                () => {
                    this.recalculateOpenItems();
                },
                { once: true },
            );
        }
    }

    static faqItemInit(): void {
        const faqSections = document.querySelectorAll('.js-faq-section-init');

        faqSections.forEach((section: Element) => {
            this.initFaqSection(section);
        });
    }

    private static initResizeHandler(): void {
        let resizeTimer: ReturnType<typeof setTimeout>;

        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                this.recalculateOpenItems();
            }, 150);
        });
    }

    private static recalculateOpenItems(): void {
        const activeItems = document.querySelectorAll('.faq-item.is-active');

        activeItems.forEach((item: Element) => {
            const content = item.querySelector('.faq-item__content') as HTMLElement;
            if (!content) return;

            content.style.transition = 'none';
            content.style.maxHeight = content.scrollHeight + 'px';

            requestAnimationFrame(() => {
                content.style.transition = 'max-height 0.3s ease-out';
            });
        });
    }

    private static initFaqSection(section: Element): void {
        const faqItems = section.querySelectorAll('.faq-item');

        faqItems.forEach((item: Element) => {
            const trigger = item.querySelector('.faq-item__trigger') as HTMLElement;
            const content = item.querySelector('.faq-item__content') as HTMLElement;

            if (!trigger || !content) return;

            this.setupInitialState(item as HTMLElement, content);

            trigger.addEventListener('click', (e: Event) => {
                e.preventDefault();
                this.toggleFaqItem(item as HTMLElement, content);
            });
        });
    }

    private static setupInitialState(item: HTMLElement, content: HTMLElement): void {
        if (item.classList.contains('is-active')) {
            content.style.maxHeight = content.scrollHeight + 'px';
            content.style.overflow = 'hidden';
        } else {
            content.style.maxHeight = '0px';
            content.style.overflow = 'hidden';
        }

        content.style.transition = 'max-height 0.3s ease-out';
    }

    private static toggleFaqItem(item: HTMLElement, content: HTMLElement): void {
        const isActive = item.classList.contains('is-active');

        if (isActive) {
            item.classList.remove('is-active');
            content.style.maxHeight = '0px';
        } else {
            item.classList.add('is-active');
            content.style.maxHeight = content.scrollHeight + 'px';

            setTimeout(() => {
                if (item.classList.contains('is-active')) {
                    content.style.maxHeight = 'auto';
                }
            }, 300);
        }
    }
}
